export default {
    fr: {
        common: {
            search: 'Rechercher',
            yes: 'Oui',
            no: 'Non',
            loading: 'Chargement...',
            seeMore: 'Voir plus',
            free: 'Gratuit'
        },
        home: {
            eventsFound: '<strong>{count}</strong> événement trouvé | <strong>{count}</strong> événements trouvés',
            noEvents: 'Aucun événement disponible pour le moment.',
            noEventsWithFilters: 'Aucun événement ne correspond à vos critères de recherche.'
        },
        sidebar: {
            display: 'AFFICHAGE :',
            filters: 'FILTRES',
            stores: 'MAGASINS',
            themes: 'THÉMATIQUES',
            price: 'PRIX',
            all: 'Tous',
            none: 'Aucun',
            free: 'Gratuit',
            paid: 'Payant',
            searchPlaceholder: 'Rechercher un événement...'
        },
        events: {
            reserve: 'JE RÉSERVE',
            allDay: 'Toute la journée',
            seats: '{count} place | {count} places',
            freeSeats: '{count} place disponible | {count} places disponibles',
            lastSeats: 'Dernières places !'
        },
        series: {
            dateRange: 'Du {start} au {end}',
            pickDay: 'Choisissez votre jour',
            pickSession: 'Choisissez votre créneau',
            sessionsAvailable: '{count} créneau disponible | {count} créneaux disponibles',
            noSessionsForDay: 'Aucun créneau disponible ce jour-là'
        },
        calendar: {
            days: ['LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM', 'DIM'],
            months: [
                'JANVIER', 'FÉVRIER', 'MARS', 'AVRIL', 'MAI', 'JUIN',
                'JUILLET', 'AOÛT', 'SEPTEMBRE', 'OCTOBRE', 'NOVEMBRE', 'DÉCEMBRE'
            ]
        },
        modals: {
            participant: {
                title: 'Vos informations',
                form: {
                    email: 'Email',
                    firstname: 'Prénom',
                    lastname: 'Nom',
                    address: 'Adresse',
                    phone: 'Téléphone',
                    loyalty_card_number: 'Numéro de carte de fidélité'
                },
                submit: 'Valider'
            }
        },
        groupBooking: {
            multiplePersons: 'Plusieurs personnes',
            addGuest: 'Ajouter une personne',
            removeGuest: 'Supprimer',
            guestFirstname: 'Prénom de la personne {number}',
            guestsCount: '{count} personne accompagnante | {count} personnes accompagnantes',
            notEnoughSeats: 'Il n\'y a pas assez de places disponibles pour ce groupe.'
        },
        workshops: {
            notifications: {
                registered: {
                    title: 'Inscription confirmée',
                    message: 'Vous êtes inscrit à cet événement.'
                },
                unregistered: {
                    title: 'Désinscription confirmée',
                    message: 'Vous avez été désinscrit de cet événement.'
                }
            },
            errors: {
                already_registered: 'Vous êtes déjà inscrit à cet événement.',
                workshop_full: 'Cet événement est complet.',
                workshop_not_available: 'Ce créneau n\'est plus disponible.',
                workshop_not_found: 'Événement introuvable.',
                email_not_allowed: 'Vous ne pouvez pas utiliser cette adresse mail pour vous inscrire'
            }
        },
        errors: {
            base: 'Une erreur est survenue. Veuillez réessayer.',
            privateAccessDenied: 'Accès refusé. Le lien d\'accès privé est invalide ou a expiré.'
        },
        payment: {
            backToWorkshops: 'Retour aux événements',
            success: {
                title: 'Paiement réussi !',
                message: 'Votre inscription a été confirmée.',
                workshopConfirmed: 'Vous êtes inscrit à l\'événement "{name}".',
                emailNotice: 'Vous allez recevoir un email de confirmation.'
            },
            cancel: {
                title: 'Paiement annulé',
                message: 'Votre inscription n\'a pas été finalisée.',
                seatReleased: 'Votre place a été libérée.'
            }
        }
    }
}
